import {SpringPageable} from "@variocube/app-ui";
import {useMemo} from "react";
import {useAccessToken} from "../auth";
import {useClientId} from "../ClientIdProvider";
import {useTenantId} from "../tenant";
import {createApiClientWithBaseConfig} from "./client";
import {BulkEndCreation} from "./client.gen";

export function useBulkBookingOperationApi() {
	const accessToken = useAccessToken();
	const tenantId = useTenantId();
	const clientId = useClientId();
	return useMemo(() => createBulkBookingOperationApi(tenantId, accessToken, clientId), [tenantId, accessToken, clientId]);
}

function createBulkBookingOperationApi(tenantId: string, accessToken?: string, clientId?: string) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, accessToken);
	return {
		createBulkEndOperation: (creation: BulkEndCreation) =>
			api.post(
				"/api/tenants/{tenantId}/bulk-booking-operations",
				withConfig({
					path: {tenantId},
					body: creation,
				}),
			),
		queryBulkBookingOperations: (query: SpringPageable) =>
			api.get(
				"/api/tenants/{tenantId}/bulk-booking-operations",
				withConfig({
					path: {tenantId},
					query,
				}),
			),
		restoreBulkEndOperation: (operationId: number) =>
			api.post(
				"/api/tenants/{tenantId}/bulk-booking-operations/{operationId}/restore",
				withConfig({
					path: {tenantId, operationId},
				}),
			),
	};
}
